module.exports = __webpack_public_path__ + "static/media/pecuaria-subheader.c54f865a.jpg";